// Wrapper fino sobre las Cloud Functions de leads/CRM (Postgres/Neon).
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const listarLeadsFn = httpsCallable(functions, 'listarLeads');
const obtenerLeadFn = httpsCallable(functions, 'obtenerLead');
const crearLeadFn = httpsCallable(functions, 'crearLead');
const crearLeadsMasivoFn = httpsCallable(functions, 'crearLeadsMasivo');
const actualizarLeadFn = httpsCallable(functions, 'actualizarLead');
const actualizarLeadsMasivoFn = httpsCallable(functions, 'actualizarLeadsMasivo');
const eliminarLeadsMasivoFn = httpsCallable(functions, 'eliminarLeadsMasivo');
const agregarNotaLeadFn = httpsCallable(functions, 'agregarNotaLead');

export async function listarLeads() {
  const result = await listarLeadsFn();
  return result.data.leads;
}

export async function obtenerLead(id) {
  const result = await obtenerLeadFn({ id });
  return result.data.lead;
}

export async function crearLead(datos) {
  const result = await crearLeadFn(datos);
  return result.data.lead;
}

export async function crearLeadsMasivo(leads) {
  const result = await crearLeadsMasivoFn({ leads });
  return result.data.count;
}

export async function actualizarLead(id, campos) {
  const result = await actualizarLeadFn({ id, ...campos });
  return result.data.lead;
}

export async function actualizarLeadsMasivo(ids, campos) {
  const result = await actualizarLeadsMasivoFn({ ids, campos });
  return result.data.count;
}

export async function eliminarLeadsMasivo(ids) {
  const result = await eliminarLeadsMasivoFn({ ids });
  return result.data.count;
}

export async function agregarNotaLead(leadId, texto, tipo = 'nota') {
  const result = await agregarNotaLeadFn({ leadId, texto, tipo });
  return result.data.nota;
}
